export const api_endpoint = "https://ase-tefter-prod.azurewebsites.net/";
